import http from  './axios'

//字典值
export const dictList = param =>{return http.post("common/common/selectDictDataList",param).then(res=>res.data.data)};

//上传文件
export const uploadFile = param =>{return http.post("common/common/uploadFile",param).then(res=>res.data.data)};

//下载/预览文件
export const downloadFile = param =>{return http.get("common/common/downLoadFile",param).then(res=>res.data)};

//判断是否登录
export const isLogin = param =>{return http.post("passport/getLoginUser",param).then(res=>res.data.data)};

//查询所有省份
export const provinceList = param => { return http.post("common/common/selectProvinceList",param).then(res=>res.data)}
//根据编码获取下一级信息
export const nextList = (param,regionCode) => { return http.post("common/common/selectNextList?regionCode="+regionCode,param,param).then(res=>res.data)}
//根据字典类型获取数据
export const selectDictDataListByDictCode = param => { return http.post("common/common/selectDictDataListByDictCode",param).then(res=>res.data)}



// WEBPACK FOOTER //
// ./src/api/common.js